















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SearchCondition, SimpleCalendarDate } from '@/modules/reservationCalendar';
import {
  ScheduleCalendarHeaderDate, ScheduleCalendarMode, TutorSchedule, Schedule
} from '@/modules/schedule';
import { Calendar } from '@/modules/calendar';
import ScheduleCalendar from '@/components/schedule/scheduleCalendar.vue';
import { Subject } from '@/models/subject';
import { SubmitArgs as StudentSelectedArgs } from '@/components/student/studentSelectDialog.vue';
import { Student } from '@/modules/student';
import { Person } from '@/models/person';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';

@Component({
  components: {
    ScheduleCalendar,
  }
})
export default class extends AvaivaledVue {
  private get isMini(): boolean { return (this as any).$mq === 'mini'; }
  private get pageTitle() { return '全体予約カレンダー'; }
  private get headerIcon() { return 'far fa-calendar-alt fa-2x'; }
  private get isLoading() {
    return this.$store.state.reservationCalendar.isLoading ||
      this.$store.state.schedule.isLoading ||
      this.$store.state.tutor.isLoading ||
      this.$store.state.calendar.isLoading;
  }

  private get condition(): SearchCondition { return this.$store.state.reservationCalendar.searchCondition; }
  private get calendar(): Calendar { return this.$store.state.calendar.info; }
  private get schedules(): TutorSchedule[] {
    const copy = JSON.parse(JSON.stringify(this.calendar.schedules));
    return copy.filter((tutorSchedule: TutorSchedule) => {

      // 講師ＩＤ検索
      if (this.condition.tutorId.length > 0) {
        if (tutorSchedule.tutorId !== this.condition.tutorId) {
          return false;
        }
      }

      tutorSchedule.schedules = tutorSchedule.schedules.filter((schedule: Schedule) => {

        // 予約条件検索
        if (this.condition.isReservedOnly) {
          if (!schedule.reservers || schedule.reservers.length < 1) {
            return false;
          }
        }

        // 教科ＩＤ検索
        if (this.condition.subjectId > 0) {
          const findSubject = schedule.subjects.find((subject: Subject) => {
            return subject.id === this.condition.subjectId;
          });
          if (findSubject === undefined) {
            return false;
          }
        }
        return true;
      });
      return true;
    });
  }

  private get headerTopDate(): Date { return this.condition.headerTopDate; }
  private set headerTopDate(date: Date) {
    this.condition.headerTopDate = date;
  }
  private ScheduleCalendarMode = ScheduleCalendarMode;
  private subjects: Subject[] = [];
  private showSearchCondition = true;
  private headers: ScheduleCalendarHeaderDate[] = [];

  private studentSelectVisible = false;
  private selectSubjectVisible = false;
  private selectedSubject: Subject = { id: 0, name: '', color: '' };
  private selectedSubjectId = 0;
  private selectedStudents: Person[] = [];

  private addSchedule: Schedule = {
    scheduleId: 0,
    weekday: 0,
    unixtimeDate: null,
    stringStart: '',
    stringEnd: '',
    subjects: [],
    capacity: 0,
    reservers: [],
    memo: '',
  };
  @Watch('selectedSubjectId')
  private onChangedSelectedSubjectId() {
    this.selectedSubject = this.addSchedule.subjects.find((subject: Subject) => {
      return subject.id === this.selectedSubjectId;
    }) as Subject;
  }

  private async onSubmitSelectedStudents(args: StudentSelectedArgs) {
    const before = this.selectedStudents;
    const after = JSON.parse(JSON.stringify(args.selectedStudents));

    const senderStudents: Person[] = [];
    after.forEach((val: Person) => {
      const isNew = before.find((val2: Person) => {
        return val2.id === val.id;
      }) === undefined;
      if (isNew) {
        senderStudents.push(val);
      }
    });

    if (senderStudents.length === 0) {
        this.$alert('生徒の選択がありませんでした', '', {
          type: 'error',
          confirmButtonText: 'OK',
        });
    } else {
      for (const student of senderStudents) {
        const response = await this.$store.dispatch('studentCalendar/sendReservation', {
          calendarId: this.calendar.calendarId,
          scheduleId: this.addSchedule.scheduleId,
          studentId: student.id,
          subjectId: this.selectedSubject.id,
          isForce: true,
        }).catch();
        if (response && response.status === 201) {
          this.$notify({
            type: 'success',
            title: response.message,
            message: `${student.name}の予約を行いました。`,
            position: 'bottom-right'
          });
        } else {
          this.$notify({
            type: 'error',
            title: '予約エラー',
            message: response.message,
            position: 'bottom-right'
          });
        }
      }

      // 編集モーダルを閉じる
      (this.$refs.scheduleCalendar as any).closeEditModal();

      // データ再読み込み
      this.loadData();
    }
  }

  private onCancelSelectedStudents() {
    const a = 1;
  }

  private async loadData() {

    this.$store.commit('reservationCalendar/setIsLoading', true);

    // 全ての日付を取得
    await this.$store.dispatch('reservationCalendar/getDatesRequest')
      .catch((error) => null);

    // 全ての講師を取得
    await this.$store.dispatch('tutor/searchTutors', {
      authoriry: 2,
      keyWord: '',
      perPage: 10000,
      page: 1,
      sort: '',
    });

    // スクール情報を取得
    const school = await this.$store.dispatch('adminSchool/getSchool', this.$store.getters['auth/schoolId']);
    this.subjects = JSON.parse(JSON.stringify(school.subjectList));

    this.$store.commit('reservationCalendar/setIsLoading', false);

    const tempId = this.condition.id;
    this.condition.id = 0;
    this.$nextTick(() => {
      this.condition.id = tempId;
      if (!this.condition.id && this.$store.state.reservationCalendar.dates.length > 0) {
        this.condition.id = this.$store.state.reservationCalendar.dates[0].id;
      }
    });
  }
  private mounted() {
    this.loadData();
  }

  private created() {
    this.pageBackCheck(FunctionTypes.Reserve);
  }

  private deactivated() {
    this.$destroy();
  }

  private dateToString(date: Date) {
    return `${date.getFullYear()}年${('00' + (date.getMonth() + 1)).slice(-2)}月`;
  }

  @Watch('condition.id')
  private async onChangedId() {
    if (this.condition.id < 1) { return; }
    await this.$store.dispatch('calendar/getInfoRequest', this.condition.id);

    if (this.headerTopDate.getMonth() !== this.calendar.month - 1) {
      this.headerTopDate = new Date(this.calendar.year, this.calendar.month - 1, 1, 0, 0, 0);
    } else {
      const checkDate = new Date(this.headerTopDate);
      checkDate.setDate(checkDate.getDate() + 6);
      if (checkDate.getMonth() !== this.calendar.month - 1) {
        const newDate = new Date(this.calendar.year, this.calendar.month, 1, 0, 0, 0);
        newDate.setDate(newDate.getDate() - 7);
        this.headerTopDate = newDate;
      } else {
        this.headerTopDate = new Date(this.headerTopDate);
      }
    }
  }

  @Watch('headerTopDate')
  private onChangedHeaderTopDate() {
    this.headers = [];
    for (let i = 0; i < 7; ++i) {
      const date = new Date(this.headerTopDate);
      date.setDate(this.headerTopDate.getDate() + i);
      this.headers.push({ date, weekday: date.getDay() });
    }
  }

  private clickArrowButton(num: number) {
    let date = this.headerTopDate.getDate() + num;
    const lastDate = new Date(this.headerTopDate.getFullYear(), this.headerTopDate.getMonth() + 1, 0).getDate() - 6;
    if (date <= 0) { date = 1; }
    if (date > lastDate) { date = lastDate; }

    this.headerTopDate.setDate(date);
    this.headerTopDate = new Date(this.headerTopDate);
  }

  private clickReserverName(studentId: string) {
    this.$router.push({
      name: 'StudentCalendar',
      params: {
        studentId
      }
    });
  }
  private clickAddReserver(scheduleId: number) {
    let findSchedule: Schedule | undefined;
    this.schedules.find((tutorSchedule: TutorSchedule) => {
      findSchedule = tutorSchedule.schedules.find((schedule: Schedule) => {
        return schedule.scheduleId === scheduleId;
      });
      return findSchedule !== undefined;
    });

    if (findSchedule !== undefined) {
      this.addSchedule = findSchedule;
      this.selectedStudents = JSON.parse(JSON.stringify((findSchedule as Schedule).reservers));
      this.selectedSubjectId = this.addSchedule.subjects[0].id;
      if ((findSchedule as Schedule).subjects.length === 1) {
        this.studentSelectVisible = true;
        this.selectedSubject = this.addSchedule.subjects[0];
      } else {
        this.selectSubjectVisible = true;
      }
    }
  }

  private addSubject() {
    this.studentSelectVisible = true;
    this.selectSubjectVisible = false;
  }
}
